module.exports = __webpack_public_path__ + "media/images/pc/top/area_brand_an-27ce18dba4fde788276118c42ac8d471.webp";